import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getHHmm } from './CalendarUtil';

function BookingTimeSlot(props) {

    function onClick() {
        props.onSelected(props.slot);
    }

    function noFreeSlots() {
        return props.empty;
    }

    if (noFreeSlots()) {
        return (
            <Button className="timeslot-text no-horizontal-padding" variant="secondary" disabled block>
                Inga <br /> tider
            </Button>
        );
    } else {
        return (
            <OverlayTrigger placement="right" overlay={
                <Tooltip>
                    Välj denna tid
                </Tooltip>
            }>
                <Button className="timeslot-text no-horizontal-padding" variant="timeslot" onClick={onClick} block>
                    {getHHmm(props.slot.start)}
                </Button>
            </OverlayTrigger>
        );
    }
}

export default BookingTimeSlot;